// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import ConfigurationService from '@/admin/configuration/configuration.service';
import GatewayService from '@/admin/gateway/gateway.service';
/* tslint:disable */
import ConvocatoriaService from '@/entities/convocatoria/convocatoria.service';
import FirmaService from '@/entities/firma/firma.service';
import FirmableService from '@/entities/firmable/firmable.service';
import ModalidadService from '@/entities/modalidad/modalidad.service';
import ProcesoService from '@/entities/proceso/proceso.service';
import SolicitudService from '@/entities/solicitud/solicitud.service';
import NotificacionService from '@/entities/notificacion/notificacion.service';
import TranslationService from '@/locale/translation.service';
import AlertService from '@/shared/alert/alert.service';
import { CvuApi, PersonaFisicaApi, PersonaMoralApi } from '@conacyt/cvu-client';
import { Configuration as FirmaConfiguration, FirmaApi as FirmaClientApi } from '@conacyt/firma-client';
import SignerComponent from '@conacyt/signer';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Vue from 'vue';
import InfiniteLoading from 'vue-infinite-loading';
import Vue2Filters from 'vue2-filters';
import '../content/scss/vendor.scss';
import AccountService from './account/account.service';
import LoginService from './account/login.service';
import AuditsService from './admin/audits/audits.service';
import HealthService from './admin/health/health.service';
import LogsService from './admin/logs/logs.service';
import MetricsService from './admin/metrics/metrics.service';
import App from './app.vue';
import router from './router';
import * as config from './shared/config/config';
import axios from 'axios';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import { VERSION, APP_DISTRIBUTION } from '@/constants';
// custom
import { Configuration } from './shared/formalizacion-client';
// import * as bootstrapVueConfig from './shared/config/config-bootstrap-vue';
import JhiItemCountComponent from './shared/jhi-item-count.vue';
import PdfObjectComponent from './shared/pdf-object/pdf-object.vue';
import JhiSortIndicatorComponent from './shared/sort/jhi-sort-indicator.vue';

import { Configuration as CurpValidateConfigurarion, ValidateApi } from '@/shared/curp-validate-client';
import { Configuration as FirmaCurpConfigurarion, FirmaCurpApi } from '@/shared/firma-curp-client';
import { Configuration as PerfilApiConfigurarion, PerfilApi } from '@conacyt/perfil-usuario-client';
import { Configuration as ReniecytApiConfiguration, ReniecytApi } from '@conacyt/persona-moral-reniecyt-client';

// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

/* tslint:enable */
Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initFortAwesome(Vue);
// bootstrapVueConfig.initBootstrapVue(Vue);
Vue.use(Vue2Filters);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(SignerComponent, {
  validator(cer: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      new FirmaClientApi(microserviceConfigFirma)
        .validate(cer)
        .then(res => {
          if (res.data !== 'GOOD') {
            console.warn(`Respuesta servicio de SAT: ${res.data}`);
          }
          resolve(res.data === 'GOOD');
        })
        .catch(_err => reject(_err));
    });
  },
});
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('jhi-item-count', JhiItemCountComponent);
Vue.component('jhi-sort-indicator', JhiSortIndicatorComponent);
Vue.component('infinite-loading', InfiniteLoading);
Vue.component('pdf-object', PdfObjectComponent);

// Vue.use(ProblemAlerterComponent);

const i18n = config.initI18N(Vue);
const store = config.initVueXStore(Vue);

const alertService = new AlertService(store);
const translationService = new TranslationService(store, i18n);
const loginService = new LoginService();
const accountService = new AccountService(store, translationService, (<any>Vue).cookie, router);

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/not-found');
  }

  if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    accountService.hasAnyAuthorityAndCheckAuth(to.meta.authorities).then(value => {
      if (!value) {
        sessionStorage.setItem('requested-url', to.fullPath);
        next('/forbidden');
      } else {
        next();
      }
    });
  } else {
    // no authorities, so just proceed
    next();
  }
});

/* tslint:disable */
axios
  .get('sentry/config')
  .then(res => {
    if (res.data && res.data.dsn) {
      let environment = 'local';
      let tracesSampleRate: 0.25;

      if (res.data.environment) {
        environment = res.data['environment'];
      }

      if (res.data.tracesSampleRate) {
        tracesSampleRate = res.data['tracesSampleRate'];
      }

      Sentry.init({
        Vue,
        dsn: res.data['dsn'],
        beforeSend(event, hint) {
          // Check if it is an exception, and if so, show the report dialog
          if (event.exception) {
            let value = null;

            if (event.exception.values && event.exception.values.length) {
              value = event.exception.values.find(e => e.value.indexOf('navigation guard') != -1);
            } else {
              console.log(JSON.stringify(event.exception));
            }

            // Check isn't navigation guard exception
            if (!value) {
              let feedBackConfig;

              if (store.getters.account && store.getters.account.firstName) {
                const username = store.getters.account.lastName
                  ? `${store.getters.account.firstName} ${store.getters.account.lastName}`
                  : store.getters.account.firstName;

                feedBackConfig = { eventId: event.event_id, user: { name: username, email: store.getters.account.email } };
              } else {
                feedBackConfig = { eventId: event.event_id };
              }

              Sentry.showReportDialog(feedBackConfig);
            }
          }
          return event;
        },
        replaysSessionSampleRate: tracesSampleRate,
        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,
        integrations: [
          new BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracePropagationTargets: [
              'localhost',
              'dev-damcad-formalizacion.crip.conacyt.mx',
              'qa.formalizacion.conacyt.mx',
              'formalizacion.conacyt.mx',
              /^\//,
            ],
          }),
        ],
        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        tracesSampleRate: tracesSampleRate,
        environment: environment,
        release: VERSION,
        dist: APP_DISTRIBUTION,
      });
    } else {
      console.log('Sentry sin activar');
    }
  })
  .catch(err => {
    console.error('Error al realizar la configuración de sentry');
    console.error(err);
  });
/* tslint:enable */

// Configuración para el microservicio de formalización
export const microserviceConfigFormalizacion = new Configuration({
  basePath: 'services/formalizacionms/api',
});

export const microserviceConfigCvu = new Configuration({
  basePath: 'services/cvu',
});

const microserviceConfigFirma = new FirmaConfiguration({
  basePath: 'services/firma',
});

const curpValidateConfigurarion = new CurpValidateConfigurarion({
  basePath: 'services/curpvalidatems/api',
});

const firmaCurpConfigurarion = new FirmaCurpConfigurarion({
  basePath: 'services/firmacurpms/api',
});

const perfilApiConfigurarion = new PerfilApiConfigurarion({
  basePath: 'services/msperfil/api',
});

const reniecytApiConfiguration = new ReniecytApiConfiguration({
  basePath: '/services/reniecytms/api',
});

/* tslint:disable */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  provide: {
    loginService: () => loginService,

    auditsService: () => new AuditsService(),

    healthService: () => new HealthService(),

    gatewayService: () => new GatewayService(),

    configurationService: () => new ConfigurationService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),
    alertService: () => alertService,
    translationService: () => translationService,

    cvuInfoService: () => new CvuApi(microserviceConfigCvu),
    personaFisicaInfoService: () => new PersonaFisicaApi(microserviceConfigCvu),
    personaMoralInfoService: () => new PersonaMoralApi(microserviceConfigCvu),
    convocatoriaService: () => new ConvocatoriaService(microserviceConfigFormalizacion, store),
    modalidadService: () => new ModalidadService(microserviceConfigFormalizacion, store),
    procesoService: () => new ProcesoService(microserviceConfigFormalizacion, store),
    solicitudService: () => new SolicitudService(microserviceConfigFormalizacion, store),
    notificacionService: () => new NotificacionService(microserviceConfigFormalizacion),
    firmableService: () => new FirmableService(microserviceConfigFormalizacion),
    firmaService: () => new FirmaService(microserviceConfigFormalizacion),
    certificateValidatorService: () => new FirmaClientApi(microserviceConfigFirma),
    validateApi: () => new ValidateApi(curpValidateConfigurarion),
    firmaCurpApi: () => new FirmaCurpApi(firmaCurpConfigurarion),
    perfilApi: () => new PerfilApi(perfilApiConfigurarion),
    reniecytApi: () => new ReniecytApi(reniecytApiConfiguration),
    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService,
    // custom
  },
  i18n,
  store,
});
